
export default (state = {}, action) => {
    if (action.type === 'SHARE_ITEM_LINKEDIN') {
        return action.payload
    }

    return state
}